import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, labelModes } from '@/utils'

import button from '@/components/button'
import additionalComponent from '@/components/rules/commons/dialog/additional'
import mainComponent from '@/components/rules/commons/dialog/main'
import { baseClass, ruleTagsByType, ruleTypes } from '@/components/rules/utils'

function renderTagSelect(h) {
  if (this.tagEdit && !this.readonly) {
    return h(
      components.select,
      {
        props: {
          value: this.tag,
          label: this.getTranslate(`${baseClass}.tags.${this.tag}`),
          items: ruleTagsByType[this.ruleType].map(tag => {
            return {
              title: this.getTranslate(`${baseClass}.tags.${tag}`),
              value: tag
            }
          }),
          itemsDisabled: this.tagDisabled,
          labelMode: labelModes.hidden,
          dense: true,
          details: false,
          required: true
        },
        on: {
          input: event => {
            this.clickHandler('reset')
            this.$emit('tag', event)
          }
        }
      }
    )
  }
}
function renderMainComponent(h) {
  if (this.tag) {
    return h(
      mainComponent,
      {
        class: {
          [`${baseClass}-dialog__content-section`]: true
        },
        props: {
          value: this.proxy,
          tag: this.tag,
          ruleType: this.ruleType,
          readonly: this.readonly
        },
        on: {
          input: event => {
            this.proxy = event
          }
        },
        ref: 'mainComponent'
      }
    )
  }
}
function renderAdditionalComponent(h) {
  if (this.ruleType === ruleTypes.conditions) {
    if (!this.readonly) {
      return h(
        additionalComponent,
        {
          class: `${baseClass}-dialog__content-section`,
          props: {
            value: this.proxy,
            tag: this.tag,
            readonly: this.readonly
          },
          ref: 'additionalComponent'
        }
      )
    }
  }
}
function renderContent(h) {
  if (this.tag) {
    return h(
      'div',
      {
        class: `${baseClass}-dialog__content`
      },
      [
        renderTagSelect.call(this, h),
        renderMainComponent.call(this, h),
        renderAdditionalComponent.call(this, h)
      ]
    )
  }
}

function renderCloseButton(h) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        label: this.getTranslate('misc.buttons.close')
      },
      on: {
        click: () => {
          this.clickHandler('close')
        }
      }
    }
  )
}
function renderResetButton(h) {
  if (!this.readonly) {
    return h(
      button,
      {
        props: {
          label: this.getTranslate('misc.buttons.clear'),
          mode: buttonModes.flat
        },
        on: {
          click: () => {
            this.clickHandler('reset')
          }
        }
      }
    )
  }
}
function renderSaveButton(h) {
  if (!this.readonly) {
    return h(
      button,
      {
        props: {
          label: this.getTranslate('misc.buttons.save'),
          disabled: this.readonly,
          color: Colors.primary
        },
        on: {
          click: () => {
            this.clickHandler('save')
          }
        }
      }
    )
  }
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${baseClass}-dialog__footer`,
      slot: 'footer'
    },
    [
      renderCloseButton.call(this, h),
      h('div', { class: 'ff' }),
      renderResetButton.call(this, h),
      renderSaveButton.call(this, h)
    ]
  )
}

export default function(h) {
  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = 500
  }

  return h(
    components.dialog,
    {
      class: `${baseClass}-dialog`,
      props: {
        title: this.title,
        value: this.show,
        maxWidth
      },
      on: {
        input: event => {
          this.$emit('show', event)
        }
      }
    },
    [
      renderContent.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
